// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__17zav","tab":"ProcedureTabs_tab__1csdM"};